var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('receipt',{attrs:{"forwho":"s","orderid":_vm.orderHeaderId,"watermark":_vm.watermark}}),_c('div',{staticClass:"pagebreak"}),_c('receipt',{attrs:{"forwho":"c","orderid":_vm.orderHeaderId,"watermark":_vm.watermark}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }